/***********************
 * INDEX TAB3 CONTENT
 * (CALLS)
 ************************/

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Col, Row } from "reactstrap"
import { withTranslation } from "react-i18next"

import CallsTable from "./CallsTable"
import CallsChart from "./CallsChart"
import CardTableBtn from "../CardTableBtn"
// import CallsChartLinear from "./components/CallsChartLinear"

const CallsTabReporting = props => {
  const [callsData, setCallsData] = useState([])
  // Passing customers data to cards/stats
  const [customers, setCustomers] = useState()
  // Filter view related states
  const [widgetVisible, setWidgetVisible] = useState(true)
  const [tableVisible, setTableVisible] = useState(false)
  const [hideShortCalls, setHideShortCalls] = useState(false)
  const [hideRelativeCalls, setHideRelativeCalls] = useState("")

  useEffect(() => {
    if (hideShortCalls || hideRelativeCalls) {
      hideSelectedCalls()
    } else {
      setCallsData(props.data)
    }
    setCustomers(props.customers)
  }, [props.data, hideShortCalls, hideRelativeCalls])

  const hideSelectedCalls = () => {
    if (Array.isArray(props.data?.list)) {

      let filteredList = props.data.list.filter(call => true);
      if (hideShortCalls) filteredList = filteredList.filter(call => call.duration >= 60)
      if (hideRelativeCalls == 'professional') filteredList = filteredList.filter(call => call.caller_role != "relative")
      else if (hideRelativeCalls == 'relative') filteredList = filteredList.filter(call => call.caller_role == "relative")

      let filteredDurationList = filteredList.filter(call => call.duration > 0)

      const stats = {
        total: filteredList.length,
        caller_relative: 0,
        duration_total: 0,
        duration_average: 0,
        duration_median: 0,
        //group: 0,
        video: 0,
        tracker: 0,
        carephone: 0,
        phone: 0,
      }

      for (const call of filteredList) {
        if (call.caller_role === "relative") stats.caller_relative++
        //if (call.type === "group") stats.group++
        if (call.type === "video") stats.video++
        if (call.type === "tracker") stats.tracker++
        if (call.type === "carephone") stats.carephone++
        if (call.type === "phone") stats.phone++
      }

      let durationSum = 0
      for (const call of filteredDurationList) {
        durationSum += call.duration
      }
      stats.duration_total = durationSum

      if (filteredDurationList.length) {
        stats.duration_average = Math.floor(durationSum / filteredDurationList.length)
        const durations = filteredDurationList
          .map(call => call.duration)
          .sort((a, b) => a - b)
        const mid = Math.floor(durations.length / 2)
        stats.duration_median = Math.floor(
          durations.length % 2 === 0
            ? (durations[mid - 1] + durations[mid]) / 2
            : durations[mid]
        )
      }

      setCallsData({
        ...props.data,
        list: filteredList,
        stats: { ...props.data.stats, ...stats },
      })
    }
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <CardTableBtn
            hideSwitch={true}
            widgetVisible={widgetVisible}
            tableVisible={tableVisible}
            setWidgetVisible={setWidgetVisible}
            setTableVisible={setTableVisible}
            hideShortCalls={hideShortCalls}
            setHideShortCalls={setHideShortCalls}
            hideRelativeCalls={hideRelativeCalls}
            setHideRelativeCalls={setHideRelativeCalls}
          ></CardTableBtn>
          <div className="mt-2 mb-1">
            {widgetVisible && (
              <>
                <CallsChart
                  selectedType={props.selectedType}
                  customers={customers}
                  data={callsData}
                  start={props.start}
                  end={props.end}
                  quickGuide={props.quickGuide}
                />
                {/* <CallsChartLinear data={callsData} /> */}
              </>
            )}
            {tableVisible && (
              <CallsTable
                minRows={0}
                selectedType={props.selectedType}
                data={callsData}
              />
            )}
          </div>
        </Col>
      </Row>
    </React.Fragment>
  )
}

CallsTabReporting.propTypes = {
  data: PropTypes.any,
  customers: PropTypes.any,
  selectedType: PropTypes.any,
  start: PropTypes.any,
  end: PropTypes.any,
  quickGuide: PropTypes.any,
}

export default withTranslation()(CallsTabReporting)
